import {request} from "@/backend/backend_util.ts";
import {Shoutout} from "@/types/DataTypes.ts";

export const shoutoutBackend = {
    getShoutouts: request<Shoutout[]>('GET', '/shoutout'),
    submit: (shoutout: Shoutout) => request('POST', '/shoutout')(shoutout),
}